import { useEffect, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

const BASE_URL = process.env.REACT_APP_BASE_URL || '';

// Shared broker dropdown for the offer forms. Loads active brokers on mount
// and returns the selected Broker's ObjectId via onChange. Extended-LOB
// forms (PGMA/PGM/RcPro) and the simple LOB drawer all use this so the
// resulting offer carries a broker link that survives the offer→policy
// chain (Test Run 7-24: commissions depend on Policy.broker being an
// ObjectId; offer forms previously captured no broker at all).
const BrokerSelect = ({ value, onChange, inputStyle, disabled }) => {
  const { t } = useTranslation();
  const [brokers, setBrokers] = useState([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const resp = await axios.get(`${BASE_URL}/brokers?limit=500&status=active`, { withCredentials: true });
        if (!cancelled) setBrokers(Array.isArray(resp.data?.data) ? resp.data.data : []);
      } catch { /* non-fatal — dropdown just stays empty */ }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <select
      value={value || ''}
      onChange={e => onChange && onChange(e.target.value)}
      disabled={disabled}
      style={{ ...inputStyle, cursor: disabled ? 'not-allowed' : 'pointer' }}
    >
      <option value=''>
        {brokers.length
          ? t('offers.brokerSelect.pickBroker', { defaultValue: 'Select broker (optional)' })
          : t('offers.brokerSelect.noBrokers', { defaultValue: 'No brokers configured' })}
      </option>
      {brokers.map(b => (
        <option key={b._id} value={b._id}>
          {b.name}{b.email ? ` — ${b.email}` : ''}
        </option>
      ))}
    </select>
  );
};

export default BrokerSelect;
